import * as React from 'react';
import { config } from '../config/config';
import {authenticationService} from "./authenticationService";
import {SectionLoader} from "../ap/base/loader";

type Props = {
  content: React.ReactNode | any;
};

type State = {
  isLoading: boolean;
};

class AuthenticationProvider extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }

  componentDidMount() {
    // if no auth0 script provided then skip
    if (!config.auth.authScriptUrl) {
      this.setState({ isLoading: false });
      return;
    }

    // remove auth0 mock script
    Array.from(document.body.querySelectorAll('script')).forEach((script) => {
      if (script.src.indexOf('auth0-script-mock') >= 0) {
        document.body.removeChild(script);
      }
    });

    const script = document.createElement('script');
    script.src = config.auth.authScriptUrl;
    script.onload = () => {
      authenticationService.initialise().then(() => {
        authenticationService.isAuthenticated().then((isAuthenticated) => {
          // TEMP FIX: force login and set maxAge to 0 to prevent users being
          // stuck in a reauth-required loop on session timeout
          isAuthenticated
            ? this.setState({ isLoading: false })
            : authenticationService.login({forceLogin: true, maxAge: '0'});
        });
      });
    };
    script.onerror = () => {
      console.error('Error in authenticating!');
    };
    document.body.appendChild(script);
  }

  render() {
    const { isLoading } = this.state;
    const { content } = this.props;
    return isLoading ? <SectionLoader/> :  <div>{content}</div>;
  }
}

export default AuthenticationProvider;
